import React from 'react';
import RSBanner from "../../../assets/images/banner/rs-banner.jpg";
import RSBanner1 from "../../../assets/images/banner/rs-banner1.jpg";
import RSBanner2 from "../../../assets/images/banner/rs-banner2.jpg";

const BottomRightAds = () => {
    return (
        <div
            id="sidebar_right"
            style={{ position: "relative", top: 0, paddingTop: 0 }}>
            <div className="clear" />
            <div>
                <img src={RSBanner} width={300} alt="RSBanner" />
            </div>
            <div>
                <img src={RSBanner1} width={300} alt="RSBanner1" />
            </div>
            <div>
                <img src={RSBanner2} width={300} alt="RSBanner2" />
            </div>
            <div></div>
        </div>

    );
};

export default BottomRightAds;